import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getCategories = (parentId = null, lazy = false) => {
  return new Promise((resolve, reject) => {
    let url = process.env.REACT_APP_APIUrl + NetworkConfiguration.CATEGORIES;
    const params = new URLSearchParams();
    if (parentId) params.append("parentId", parentId);
    if (lazy) params.append("lazy", "1");

    const queryString = params.toString();
    if (queryString) url += `?${queryString}`;

    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAllCategories = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ALL_CATEGORIES,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const searchCategories = (searchTerm) => {
  return new Promise((resolve, reject) => {
    // Use the main categories endpoint which should return the full database category tree
    const params = new URLSearchParams({ search: searchTerm });
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CATEGORIES + `?${params.toString()}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const searchCategoriesByKeyword = (keyword) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({ keyword: keyword.trim() });
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.SEARCH_CATEGORIES_BY_KEYWORD + `?${params.toString()}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const CategoryApiService = {
  getCategories,
  getAllCategories,
  searchCategories,
  searchCategoriesByKeyword,
};
